
import * as swiper from  './swiper';

export function exec () {
	$(document).ready(() => {
		swiper.exec();
	});
}



// WEBPACK FOOTER //
// ./client/src/core/components/swiper/index.js